import React from 'react'
import Table from './Table'
import { addUrl, getRoom, deletePerson } from '../firebase'
import { getColor } from './Colors'
import Nav from './Nav'


export default class Room extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      room_code: props.match.params.roomId,
      url: "",
      name: "",
      timetable_data: {},
      users: []
    }
  }

  componentWillMount() {
    getRoom(this.state.room_code).on('value', snapshot => {
      if (snapshot.val()) {
        let data = snapshot.val()
        let users = []
        Object.keys(data).forEach((user, index) => users.push({ name: user, color: getColor(index) }))
        this.setState({ timetable_data: data, users: users })
      } else {
        this.setState({ timetable_data: {}, users: [] })
      }
    })
  }

  onUrlFieldChange = (event) => {
    this.setState({ url: event.target.value })
  }

  onNameFieldChange = (event) => {
    this.setState({ name: event.target.value })
  }

  addTimetable = () => {
    addUrl(this.state)
    this.setState({ name: "", url: "" })
  }

  // deletePerson(person) {
  //   deletePerson(this.state.room_code, person.name)
  // }

  render() {
    console.log("timetable data", this.state.timetable_data)
    return (
      <div className="Room">
      <Nav
        nameField={this.state.name}
        urlField={this.state.url}
        onNameChange={this.onNameFieldChange}
        onUrlChange={this.onUrlFieldChange}
        submit={this.addTimetable}
        roomcode={this.state.room_code}
        users={this.state.users}
      />

        <Table data={this.state.timetable_data} users={this.state.users} room={this.state.room_code}/>
      </div>
    )
  }
}